//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    accessibility: { type: Boolean, default: true },
    adaptiveHeight: { type: Boolean, default: false },
    arrows: { type: Boolean, default: false },
    asNavFor: { type: Object, default: null },
    autoplay: { type: Boolean, default: false },
    autoplaySpeed: { type: Number, default: 3000 },
    centerMode: { type: Boolean, default: false },
    centerPadding: { type: String, default: '50px' },
    clientOnly: { type: Boolean, default: false },
    cssEase: { type: String, default: 'ease' },
    dots: { type: Boolean, default: true },
    dotsClass: { type: String, default: 'slick-dots' },
    draggable: { type: Boolean, default: true },
    edgeFriction: { type: Number, default: 0.35 },
    fade: { type: Boolean, default: false },
    focusOnSelect: { type: Boolean, default: false },
    infinite: { type: Boolean, default: false },
    initialSlide: { type: Number, default: 0 },
    lazyLoad: { type: String, default: null },
    pauseOnDotsHover: { type: Boolean, default: false },
    pauseOnFocus: { type: Boolean, default: false },
    pauseOnHover: { type: Boolean, default: true },
    responsive: { type: Array, default: null },
    rows: { type: Number, default: 1 },
    rtl: { type: Boolean, default: false },
    slidesPerRow: { type: Number, default: 1 },
    slidesToScroll: { type: Number, default: 1 },
    slidesToShow: { type: Number, default: 1 },
    speed: { type: Number, default: 200 },
    swipe: { type: Boolean, default: true },
    swipeToSlide: { type: Boolean, default: false },
    touchMove: { type: Boolean, default: true },
    touchThreshold: { type: Number, default: 5 },
    useCSS: { type: Boolean, default: true },
    useTransform: { type: Boolean, default: true },
    variableWidth: { type: Boolean, default: false },
    vertical: { type: Boolean, default: false },
    waitForAnimate: { type: Boolean, default: true },
    disableOnDesktop: { type: Boolean, default: false }
  },
  computed: {
    hasContent () {
      if (!this.$slots) return false
      return (this.$slots.default || []).length
    }
  },
  beforeDestroy () {
    try {
      if (this.$refs.slider) this.$refs.slider.$destroy()
    } catch (error) { this.$sentry.captureException(error) }
  },
  methods: {
    next () { return this.$refs.slider.next() },
    prev () { return this.$refs.slider.prev() },
    play () { return this.$refs.slider.play() },
    pause () { return this.$refs.slider.pause() },
    goTo (slide, animate = true) { return this.$refs.slider.goTo(slide, animate) }
  }
}
